import { capitalizeFirstLetter } from "@/utils/capitalizeFirstLetter";
import { formatNumber } from "@/utils/formatNumber";
import React from "react";

const Summary = ({
  uploadedUrls,
  bedroomCount,
  number_of_plots,
  bathroomCount,
  furnished,
  address,
  shared,
  serviced,
  negotiable,
  currency,
  city,
  price,
  state,
  legal_fees,
  agency_fees,
  caution_fee,
  totalPackage,
  propertyType,
  category,
  amenities,
}: any) => {
  const previewUrls = uploadedUrls;
  console.log("preview Urls", uploadedUrls);
  return (
    <div>
      <p className=" text-main-900 font-medium text-base">Listing summary</p>
      <div className="flex flex-col lg:flex-row gap-[16px]">
        <div className="flex flex-col gap-4 w-[100%] p-5 lg:w-[50%] h-fit bg-weak-100 rounded-2xl mt-4">
          {number_of_plots ? (
            <div className="w-[100%] flex justify-between">
              <p
                className="
          text-grey-7 font-normal"
              >
                Number of square meters
              </p>
              <p
                className="
          text-grey-7 font-semibold"
              >
                {number_of_plots ?? "N/A"}
              </p>
            </div>
          ) : (
            <>
              <div className="w-[100%] flex justify-between">
                <p
                  className="
          text-grey-7 font-normal"
                >
                  Bedroom
                </p>
                <p
                  className="
          text-grey-7 font-semibold"
                >
                  {bedroomCount ?? "N/A"}
                </p>
              </div>
              <div className="w-[100%] flex justify-between">
                <p
                  className="
          text-grey-7 font-normal"
                >
                  Bathroom
                </p>
                <p
                  className="
          text-grey-7 font-semibold"
                >
                  {bathroomCount ?? "N/A"}
                </p>
              </div>
            </>
          )}

          <div className="w-[100%] flex justify-between">
            <p
              className="
          text-grey-7 font-normal"
            >
              Property type
            </p>
            <p
              className="
          text-grey-7 font-semibold"
            >
              {capitalizeFirstLetter(propertyType) ?? "N/A"}
            </p>
          </div>

          {category && (
            <div className="w-[100%] flex justify-between">
              <p
                className="
          text-grey-7 font-normal"
              >
                Category
              </p>
              <p
                className="
          text-grey-7 font-semibold"
              >
                {capitalizeFirstLetter(category) ?? "N/A"}
              </p>
            </div>
          )}

          {amenities && amenities.length > 0 && (
            <div className="w-[100%] flex justify-between">
              <p
                className="
          text-grey-7 font-normal"
              >
                Amenities
              </p>
              <p
                className="
          text-grey-7 font-semibold"
              >
                {amenities
                  .map((a: string) =>
                    a
                      .replace(/_/g, " ")
                      .replace(/\b\w/g, (c: string) => c.toUpperCase()),
                  )
                  .join(", ")}
              </p>
            </div>
          )}

          <div className="w-[100%] flex justify-between">
            <p
              className="
          text-grey-7 font-normal"
            >
              Furnished
            </p>
            <p
              className="
          text-grey-7 font-semibold"
            >
              {capitalizeFirstLetter(furnished) ?? "N/A"}
            </p>
          </div>

          <div className="w-[100%] flex justify-between">
            <p
              className="
          text-grey-7 font-normal"
            >
              Negotiable
            </p>
            <p
              className="
          text-grey-7 font-semibold"
            >
              {negotiable ?? "N/A"}
            </p>
          </div>

          <div className="w-[100%] flex justify-between">
            <p
              className="
          text-grey-7 font-normal"
            >
              Shared
            </p>
            <p
              className="
          text-grey-7 font-semibold"
            >
              {shared ?? "N/A"}
            </p>
          </div>
          <div className="w-[100%] flex justify-between">
            <p
              className="
          text-grey-7 font-normal"
            >
              Serviced
            </p>
            <p
              className="
          text-grey-7 font-semibold"
            >
              {serviced ?? "N/A"}
            </p>
          </div>

          <div className="w-[100%] flex justify-between">
            <p
              className="
          text-grey-7 font-normal"
            >
              Location
            </p>
            <p
              title={address}
              className="
          text-grey-7 font-semibold max-w-[200px] truncate"
            >
              {address ?? "N/A"}
            </p>
          </div>

          <div className="w-[100%] flex justify-between">
            <p
              className="
          text-grey-7 font-normal"
            >
              Total Package
            </p>
            <p
              className="
          text-grey-7 font-semibold"
            >
              {formatNumber(totalPackage) ?? "N/A"}
            </p>
          </div>

          <div className="w-[100%] flex justify-between">
            <p
              className="
          text-grey-7 font-normal"
            >
              Currency
            </p>
            <p
              className="
          text-grey-7 font-semibold"
            >
              {currency ?? "N/A"}
            </p>
          </div>
        </div>

        <div className="w-[100%] lg:w-[50%]">
          {previewUrls.length > 0 && (
            <div className="mt-4 flex gap-2 flex-wrap">
              {previewUrls.slice(0, 3).map((url: string, index: number) => {
                const isVideo = /\.(mp4|mov|avi|webm|mkv|m4v)$/i.test(url);

                return (
                  <div key={url} className="relative group">
                    {isVideo ? (
                      <video
                        src={url}
                        controls
                        muted
                        playsInline
                        preload="metadata"
                        className="w-[123px] h-[86.53px] object-cover rounded-lg"
                      />
                    ) : (
                      <img
                        src={url}
                        alt={`Preview ${index + 1}`}
                        className="w-[123px] h-[86.53px] object-cover rounded-lg"
                      />
                    )}
                  </div>
                );
              })}

              {previewUrls.length > 3 && (
                <div className="relative">
                  <div className="absolute inset-0 bg-black bg-opacity-60 rounded-lg flex items-center justify-center z-10">
                    <span className="text-4xl text-white font-bold">
                      +{previewUrls.length - 3}
                    </span>
                  </div>

                  {/\.(mp4|mov|avi|webm|mkv|m4v)$/i.test(previewUrls[3]) ? (
                    <video
                      src={previewUrls[3]}
                      className="w-[123px] h-[86.53px] object-cover rounded-lg"
                      muted
                    />
                  ) : (
                    <img
                      src={previewUrls[3]}
                      alt="More media"
                      className="w-[123px] h-[86.53px] object-cover rounded-lg"
                    />
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Summary;
